<template>
  <el-dialog title="重置密码" :visible="true" width="30%" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item label="" prop="oldPassword">
        <el-input v-model="form.oldPassword" placeholder="请输入旧密码" clearable show-password />
      </el-form-item>
      <el-form-item label="" prop="userPassword">
        <el-input v-model="form.userPassword" placeholder="请输入新密码" clearable show-password />
      </el-form-item>
      <el-form-item label="" prop="validatePassword">
        <el-input v-model="form.validatePassword" placeholder="请再次输入新密码" show-password clearable />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loading" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { restNewPassword } from '@/api/permission/user'
import { encrypt } from '@/utils/rsaEncrypt'
import md5 from 'js-md5'
export default {
  props: {
    param: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      form: {
        oldPassword: null,
        userPassword: null,
        validatePassword: null
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        userPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@#!%^*?&+-])[A-Za-z\d$@#!%^*?&+-]{8,}/, message: '密码应当至少8位且含有数字、大小写字母及特殊字符', trigger: 'blur' }
        ],
        validatePassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: this.checkPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    checkPassword(rule, value, callback) {
      if (value === this.form.userPassword) {
        callback()
      } else {
        callback(new Error('两次输入的密码不一致'))
      }
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.userPassword !== this.form.validatePassword) {
            this.$message.error('两次输入的密码不一致')
            return
          }
          this.loading = true
          //const id = this.param.id
          const formData = {
            //id: id,
            oldPassword:md5(this.form.oldPassword),
            password: encrypt(this.form.userPassword)
          }
          restNewPassword(formData).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$message.success('修改成功')
              setTimeout(() => {
                location.reload()
              }, 1000)
            } else {
              this.$message.error(res.msg)
            }
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
